<template>
  <div>
    <app-cells><h1 class="title">List of cash requests for orders</h1></app-cells>
    <app-tabs v-if="is_product_storage_manager || is_product_storage_supervisor" :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'ProductStorageCashLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'product-storage-cash-active', label: 'Active' },
        { name: 'product-storage-cash-completed', label: 'Completed' },
      ]
    }
  },
  computed: {
    is_product_storage_manager() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_manager')
    },
    is_product_storage_supervisor() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_supervisor')
    },
  }
}
</script>
